import { History } from "./History";
import {ArrayLoading} from "./ArrayLoading";

export class Protocol{
    protocolName: string = "";
    labId: string = "";
    protocolType:ProtocolType = null;
    protocolExtractionStepList:Array<string> = [];
    protocolExtractionStepMap: any = {};
    protocolStepList: Array<string> = [];
    protocolStepMap: any = {};
    protocolArrayStepList: Array<string> = [];
    protocolArrayStepMap: any = {};
    redoConfigurationMap: any = {};
    arrayLoading: ArrayLoading = new ArrayLoading();
    signOffBy: string = "";
    signOffDate: string = "";
    active: boolean = false;
    protocolVersion: number = 0;
    history: History[] = [];
    createdBy: string = "";
    changedBy: string = "";
    updateType: string = "";
    creationDate: Date = new Date();
    receptionRegex? : string = "";
    receptionBarcodeTemplate?: string ="";
    automatedBarcodeCreation = false;
    markedForSRC = false;
}

export enum ProtocolType{
    PLATE_ARRAY = "PLATE_ARRAY",
    EXTRACTION = "EXTRACTION"
}

export class ProtocolMeta{
    protocolName: string = "";
    protocolVersion: number = 0;
}
